import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("text-page-paragraph-block", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("text-page-paragraph-block"),
    model: {
      defaults: {
        draggable: true,
        selectable: true,
        removable: true,
        hoverable: true,
      },
    },
  });

  BlockManager.add("text-page-paragraph-block", {
    ...config,
    label: "Paragraph with title",
    content: template,
  });

  editor.on("rte:action:button-status", data => {
    if (["bulletedList", "numberedList"].includes(data.type)) {
      if (data.el.matches(".text-page-paragraph-block h2")) data.enabled = false;
    }
  });
}
